export default "__VITE_ASSET__24126316__"